import { useEffect, useState } from "react";
import Agent from "../../Components/Agent";
import "./index.css";
import LoadingView from "../../Components/Loader";
import { AGENTS_URL } from "../../Global/API's";

const AgentFinder = () => {
  const [agentsData, setAgentsData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  const getAgentsData = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(AGENTS_URL + `?search=${searchValue}`);
      const fetchedData = await response.json();
      setAgentsData(fetchedData);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAgentsData();
  }, []);

  const onSearchAgent = (e) => {
    e.preventDefault();
    getAgentsData();
  };

  const renderLoadingView = () => <LoadingView />;

  const renderAgentsView = () => (
    <>
      <h2>Real Estate Agents in Selzer Realty</h2>
      <p>
        The top agents are knowledgeable about your market and can help you
        every step of the way.
      </p>
      <div className="agents-block">
        {agentsData.data.map((agent, index) => (
          <Agent key={index} agent={agent} />
        ))}
      </div>
    </>
  );

  const renderNoAgentsView = () => (
    <div className="no-agents-container">
      <img src="/assets/images/agent-delete-icon.png" alt="" />
      <h4>No Agents Are Found</h4>
      <p>We're sorry, we couldn't find any agents matching your search.</p>
    </div>
  );

  const renderSwitchView = () => {
    if (isLoading) {
      return renderLoadingView();
    } else if (agentsData.status === "Not Found") {
      return renderNoAgentsView();
    } else if (agentsData.status === "Success") {
      return renderAgentsView();
    }
  };

  return (
    <>
      <section className="agent-banner">
        <div className="container-fluid">
          <div className="text-content">
            <h1>Find an Agent</h1>
            <p>
              Find an agent with local expertise and block-by-block knowledge of
              every neighborhood in United States.
            </p>
          </div>
          <form onSubmit={onSearchAgent}>
            <div className="search-container">
              <input
                className="form-control"
                placeholder="Search Agent"
                type="text"
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                }}
              />
              <button className="btn" type="submit">
                <i className="fa fa-search"></i> Find Agent
              </button>
            </div>
          </form>
        </div>
      </section>
      <section className="agents-container">
        <div className="container-fluid">{renderSwitchView()}</div>
      </section>
    </>
  );
};

export default AgentFinder;
